import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useHistory, useLocation, withRouter } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAllStaticPages } from "../../store/StaticPages/actions";
import {
  BetJakataAddress,
  BetJakataDescription,
  FooterLinks,
  FooterSocials,
  PaymentMethods,
} from "../../helpers/constants";
import Layout from "../Layouts/Layout";
import { HandleScroll } from "../../helpers/utils";
import { ChevronRight } from "lucide-react";
import brand from "../../brand.config";
import { Badge } from "../ui/badge";
function ContentFooter(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const history = useHistory();
  const routerLocation = useLocation();
  // useEffect(() => {
  //   dispatch(getAllStaticPages());
  // }, []);

  // const PageTypes = useSelector((state) => state?.staticPages.Index ?? []).map(
  //   (sp) => sp["page_type"]
  // );

  const currentYear = new Date().getFullYear();

  return (
     <div className="bg-[var(--bg-canvas)] border-t border-[var(--border-subtle)] py-8 px-[2rem] w-full">
      <Layout>
        <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-[240px_repeat(3,1fr)_200px]">
          <div className="text-[var(--text-muted)] text-[13px] flex flex-col gap-1">
            <div className="flex items-center gap-1.5 mb-1">
              <img src={brand.assets.logo} alt={brand.name} className="h-10 w-auto object-contain" />
            </div>
            <p>{BetJakataDescription}</p>
            <div className="flex flex-col gap-2 md:whitespace-nowrap">
              {BetJakataAddress.map((item, index) => (
                <div key={index} className="flex gap-1 items-center">
                  <span>{item.icon}</span>
                  <span>{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {FooterLinks.map((item, index) => (
            <div key={index} className="flex-col gap-2 hidden md:flex">
              <p className="text-xs font-semibold uppercase tracking-[0.10em] text-[var(--text-secondary)]">{t(item.descKey ?? item.description, item.description)}</p>
              <div className="flex flex-col gap-3 ">
                {item.links.map((type, index) => (
                  <div
                  onClick={()=>{ history.push(type.link)
                     HandleScroll()
                  }}
                    key={index}
                    className={`text-sm ${ routerLocation.pathname + routerLocation.search === type.link ? "text-[var(--gold-400)]" : "text-[var(--text-muted)]"} hover:text-[var(--gold-400)] cursor-pointer`}
                  >
                    <span>{t(type.nameKey ?? type.name, type.name)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="flex flex-col gap-3 w-full md:w-auto">
            <div className="flex flex-col gap-2">
              <p className="text-xs font-semibold uppercase tracking-[0.10em] text-[var(--text-secondary)]">{t(PaymentMethods.descKey ?? PaymentMethods.description, PaymentMethods.description)}</p>
              <div className="flex flex-wrap gap-1.5">
                {PaymentMethods.types.map((type, index) => (
                  <div
                    key={index}
                    className="h-[22px] px-1.5 !border !border-[var(--border-default)] rounded-[var(--radius-xs)] bg-[var(--surface-2)] flex items-center justify-center"
                    title={type.name}
                  >
                    <img
                      src={type.icon}
                      alt={type.name}
                      className="h-3.5 w-auto"
                    />
                  </div>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.10em] text-[var(--text-secondary)] truncate">
                <Trans i18nKey="footer_follow_us">Follow Us</Trans>
              </p>
              <div className="flex gap-1.5 mt-2">
                {FooterSocials.map((item, index) => (
                  <div
                    key={index}
                    className="w-7 h-7 !border !border-[var(--border-default)] rounded-[var(--radius-sm)] flex items-center justify-center text-[var(--text-secondary)] hover:!border-[var(--border-brand)] hover:text-[var(--gold-400)] cursor-pointer"
                  >
                    <img src={item.icon} alt={item.name} className="w-3.5" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-[1px] bg-[var(--border-subtle)] mt-8"></div>
        <div className="mt-4 flex flex-col w-full gap-3">
          <div className="flex gap-2 items-center flex-wrap">
            <Badge tone="neutral" className="whitespace-nowrap">
              <Trans i18nKey="footer_age_badge">18+</Trans>
            </Badge>
            <span className="text-xs text-[var(--text-muted)] break-words">
              <Trans i18nKey="footer_responsible_gambling_warning" values={{ brandName: brand.name }}>
                {"{brandName} is strictly for users aged 18 and above. Please bet responsibly, as excessive gambling can lead to addiction and negatively affect your mental well-being."}
              </Trans>
            </span>
          </div>
          <div className="text-xs text-[var(--text-muted)] break-words">
            <Trans i18nKey="footer_copyright">Copyright ©</Trans> {currentYear} {brand.name}.{" "}
            <Trans i18nKey="content_footer_all_rights_reserved">All Rights Reserved.</Trans>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default ContentFooter;
